import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CONTAINER_WIDTH } from '../../../constants/Layout';
import { DESKTOP } from '../../../constants/Devices';
import NavigationMenu from './navigationMenu/NavigationMenu';
import Header from './headers/Header';
import Content from './content/Content';
import Footer from '../Footer';
import FlashMessage from '../../common/FlashMessage';
import RipleyBankBannerSticky from '../../business/banners/bank/RipleyBankBannerSticky';

const useStyles = makeStyles((theme) => ({
  content: {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
    width: CONTAINER_WIDTH,
    margin: '0 auto',
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    overflow: 'scroll',
  },
}));

const DesktopLayout = () => {
  const classes = useStyles();

  return (
    <Box>
      <Header />
      <FlashMessage />
      <RipleyBankBannerSticky
        banner={{
          setAppearanceFor: DESKTOP,
        }}
      />
      <Box className={classes.content}>
        <NavigationMenu />
        <Content />
      </Box>
      <Footer />
    </Box>
  );
};

export default DesktopLayout;
